/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, warp-drive/no-legacy-request-patterns */
import Caregiver from '@linc-technologies/linced-common/models/people/caregiver';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from 'linced-app/models/person';

// Proto: people.Caregiver.
export default class _Caregiver extends Caregiver {
  declare [Type]: 'people/caregiver';

  // learners gives the people in learnerIds that are in the store. The search
  // route loads them for all caregivers in one query.
  @computed('learnerIds.[]')
  get learners(): Person[] {
    const learners: Person[] = [];
    for (const id of this.learnerIds) {
      const learner = this.store.peekRecord<Person>('person', id);
      if (learner) {
        learners.push(learner);
      }
    }
    return learners;
  }
}
